import { clearLocalAccessData } from './../utils/utils';

export const logout = (history) => {
  return (dispatch) => {
    clearLocalAccessData();
    history.push('/login');
  };
};
